import { AxiosError } from 'axios';

import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export interface ZorMeetingLink {
  meeting_link: string;
}

const getZorMeetingLink = async (): Promise<ApiResponse<ZorMeetingLink>> => {
  try {
    const response = await apiManager.get('/v1/zors/meeting-link', {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getZorMeetingLink;
